//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PopupCard from "@/pages/Sellers/components/PopupCard.vue";
import moment from "moment";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

export default {
  name: "RoutesTable",
  props: ["tableClass", "bordered", "recordsTotal", "loading", "data"],
  components: {
    PopupCard
  },
  mounted: function() {
    for (let i = 0; i < this.data.length; i++) {
      this.areaPopup.push(false);
      this.storePopup.push(false);
      this.sellerPopup.push(false);
    }
  },
  data: () => ({
    moment,
    filter: "",
    separator: "horizontal",
    pagination: {
      page: 1,
      rowsPerPage: 8
    },
    columns: [
      {
        name: "name",
        required: true,
        label: "Nome",
        align: "left",
        field: row => row.name,
        format: DEFAULT_FORMAT
      },
      {
        name: "period",
        required: true,
        label: "Período",
        align: "left",
        field: row => row.route_period.name,
        format: DEFAULT_FORMAT
      },
      {
        name: "start-date",
        required: true,
        label: "Início",
        align: "left",
        field: row => row.start_date,
        format: DEFAULT_FORMAT
      },
      {
        name: "end-date",
        required: true,
        label: "Fim",
        align: "left",
        field: row => row.end_date,
        format: DEFAULT_FORMAT
      },
      {
        name: "market",
        required: true,
        label: "Mercado",
        align: "left",
        field: row => row.market.name,
        format: DEFAULT_FORMAT
      }
    ],
    areaPopup: [],
    storePopup: [],
    sellerPopup: [],
    isClicked: [],
    lastSelectedItemPage: null,
    lastSelectedItemRow: null
  }),
  methods: {
    updateState: function(event) {
      this.pagination = event.pagination;
      this.$emit("request-new-page", event);
    },
    fetchRowData: function(index) {
      let indexOnLine = index % this.pagination.rowsPerPage;
      let data = this.data[indexOnLine];
      this.isClicked = Array(this.data.length).fill(false);
      this.isClicked.splice(indexOnLine, 1, true);
      this.lastSelectedItemPage = this.pagination.page;
      this.lastSelectedItemRow = indexOnLine;
      this.$emit("clicked-row", data);
    },
    expandArea: function(row, state) {
      this.areaPopup.splice(row, 1, state);
    },
    expandStore: function(row, state) {
      this.storePopup.splice(row, 1, state);
    },
    expandSeller: function(row, state) {
      this.sellerPopup.splice(row, 1, state);
    }
  },
  watch: {
    recordsTotal: {
      immediate: true,
      handler: function(newVal) {
        // watch it
        this.pagination.rowsNumber = newVal;
      }
    }
  }
};
